import About from './component/About';
import { Contact } from './component/Contact';
import Experience from './component/Experience';
import Home from './component/Home';
import Navbar from './component/Navbar';
import Portfolio from './component/Portfolio';
// import ResumeEmbed from './component/ResumeEmbed';
import SocialLinks from './component/SocialLinks';

function App() {


    return (
        <>
            <Navbar />
            <Home />
            <SocialLinks />
            <About />
            <Portfolio />
            <Experience />
            <Contact />
            {/* <ResumeEmbed /> */}
        </>
    );
}

export default App;
